import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import { GRAssetsBySkinId } from '../../constants/assets';
import { getGRRulesByRound } from '../../constants/rulesLabels';
import { GRContext } from '../../contexts/GRContext';
import { type GRRound } from '../../types/round';
import GRRule from '../GRRule';
import GRViewWrapper from '../GRViewWrapper/GRViewWrapper';

type StyledGRViewWrapperProps = {
  $backgroundImgPath?: string;
};

const StyledGRViewWrapper = styled(GRViewWrapper)`
  padding: 0;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;

    background: inherit;
    filter: blur(4px);
  }

  background-image: url(${({ $backgroundImgPath }: StyledGRViewWrapperProps) => $backgroundImgPath});
`;

const InnerWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 100%;

  align-items: center;
  justify-content: center;
  padding: 1em;
`;

type GRRoundRulesProps = {
  className?: string;
  roundId: GRRound;
  onFullRulesClick: () => void;
  maxPoints: number;
  minStakeMultiplicator: number;
  maxStakeMultiplicator: number;
};

const GRRoundRules = ({
  className,
  roundId,
  maxPoints,
  minStakeMultiplicator,
  maxStakeMultiplicator,
  onFullRulesClick,
}: GRRoundRulesProps) => {
  const { skinId } = useContext(GRContext);
  const backgroundImgPath = useMemo(() => (skinId ? GRAssetsBySkinId[skinId].Backgrounds?.rules : ''), [skinId]);

  const rule = useMemo(
    () => getGRRulesByRound(maxPoints, minStakeMultiplicator, maxStakeMultiplicator)[roundId],
    [maxPoints, minStakeMultiplicator, maxStakeMultiplicator, roundId],
  );

  return rule ? (
    <StyledGRViewWrapper className={className} $backgroundImgPath={backgroundImgPath}>
      <InnerWrapper>
        <GRRule {...rule} onFullRulesClick={onFullRulesClick} />
      </InnerWrapper>
    </StyledGRViewWrapper>
  ) : null;
};

export default GRRoundRules;
